import {
  hasForbiddenNameCharacters,
  MAX_SPACE_DESCRIPTION_LENGTH,
  MAX_SPACE_NAME_LENGTH,
} from 'shared';
import { z } from 'zod';

import { getTranslation } from '../../../utils/get-translation.util';

// Mirrors the backend `createWorkspaceSchema`, which stays the source of truth.
export const createWorkspaceSchema = z
  .object({
    description: z
      .string()
      .trim()
      .max(MAX_SPACE_DESCRIPTION_LENGTH, {
        message: getTranslation('CHARACTER_LIMIT_IS_COUNT', {
          count: MAX_SPACE_DESCRIPTION_LENGTH,
        }),
      }),
    name: z
      .string()
      .trim()
      .min(1, { message: getTranslation('SPACE_NAME_REQUIRED') })
      .max(MAX_SPACE_NAME_LENGTH, {
        message: getTranslation('CHARACTER_LIMIT_IS_COUNT', { count: MAX_SPACE_NAME_LENGTH }),
      })
      .refine((name) => !hasForbiddenNameCharacters(name), {
        message: getTranslation('SPACE_NAME_FORBIDDEN_CHARACTERS'),
      }),
  })
  .strict();

export type CreateWorkspaceForm = z.infer<typeof createWorkspaceSchema>;

export type CreateWorkspacePayload = {
  description: null | string;
} & Pick<CreateWorkspaceForm, 'name'>;

export const toCreateWorkspacePayload = ({
  description,
  name,
}: CreateWorkspaceForm): CreateWorkspacePayload => ({ description: description || null, name });
